// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ikXT","title":"Header_title__1oYnj","side":"Header_side__2umcM"};